import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { SettingsSiteControllerBeds24MainSection } from "./section";
import { SettingsSiteControllerBase } from "../../../_shared/base";

import type { SiteControllerSettingBaseFormModel } from "../../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingBeds24FormModel } from "../../../../../model/beds24/type";
import type { SiteControllerSettingBeds24FormModelMethodsType } from "../../../../../model/beds24/use-case/use-create-model/methods";

type Props = {
	hotelID: string;
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	beds24ViewModel: SiteControllerSettingBeds24FormModel["ViewModel"];
	siteControllerSettingBeds24FormModelMethods: SiteControllerSettingBeds24FormModelMethodsType;

	queryData: SiteControllerSettingBaseFormModel["QueryData"];
};

export const SettingsSiteControllerBeds24MainIsland = ({
	hotelID,
	baseViewModel,
	siteControllerSettingBaseFormModelMethodsType, //

	beds24ViewModel,
	siteControllerSettingBeds24FormModelMethods,

	queryData,
}: Props) => {
	return (
		<FeatureIslandContainer>
			<FeatureIslandMainWithBackGround islandTitle="基本設定">
				<SettingsSiteControllerBase
					hotelID={hotelID}
					siteControllerType={baseViewModel.siteControllerType}
					siteControllerSettingBaseFormModelMethods={siteControllerSettingBaseFormModelMethodsType}
				/>
				<SettingsSiteControllerBeds24MainSection
					roomKVList={queryData.roomKVList}
					siteControllerSettingBeds24FormModelMethods={siteControllerSettingBeds24FormModelMethods}
					beds24ViewModel={beds24ViewModel}
				/>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

SettingsSiteControllerBeds24MainIsland.displayName = "SettingsSiteControllerBeds24MainIsland";
